import {useEffect, useState} from "react";
import HeaderPage from "../../../../palette/HeaderPage";
import VerticalSpace from "../../../../palette/VerticalSpace";
import {Columns, LayoutChild} from "../../../../palette/Palette";
import Text from "../../../../palette/Text"
import {CheckBox} from 'devextreme-react/check-box';
import {Button} from 'devextreme-react/button';
import {UpdateArray, FilterByKey, FilterDelete} from "../../../../utils/HelpFunctions";
import {buttonSuccess} from "../../../../utils/ComponentsSetting";
import {db} from "../../../../firebase/Firebase";
import {useSnackbar} from 'notistack';
import {
    ErrorMessage,
    NotiStackInfo
} from "../../../../palette/NotiStackInfo";
import Results from "../../../../palette/Results";
import {Element} from 'react-scroll'
import {scrollTo} from "../../../../utils/Scroll";

function Permissions(props) {

    const {permissions, userId, setPermissions, userName, setDataUsers, data, ID, DataStore} = props

    const {vehicleDisplay} = DataStore

    const [drivers, setDrivers] = useState(null)

    useEffect(() => {
        if (vehicleDisplay !== "Orden") {
            const result = FilterDelete(permissions[2].drivers, 'text', 'Orden de conductores')
            setDrivers(result)
        } else {
            setDrivers(permissions[2].drivers)
        }

    }, [permissions])

    const [submitButton, setSubmitButton] = useState({...buttonSuccess})
    const [result, setResult] = useState(null)

    const {enqueueSnackbar} = useSnackbar();

    const onValueSimpleChanged = (key, actualValue, value) => {
        const updateArray = UpdateArray(permissions, key, actualValue, key, value)
        setPermissions(updateArray)
    }

    const onValueCompleteChanged = (root, actualValue, i, value) => {
        const filterResult = FilterByKey(permissions, root,)
        const textField = filterResult.result[root][i]
        if (textField.text === 'Todo') {
            const newArray = [...filterResult.result[root]]
            newArray.forEach(item => {
                item.value = value
            })
            let newDataArray = [...permissions];
            newDataArray[filterResult.pos][root] = newArray
            setPermissions(newDataArray)
        } else {
            const newArray = [...filterResult.result[root]]
            const updateArray = UpdateArray(newArray, 'text', actualValue, 'value', value)
            let newDataArray = [...permissions];
            newDataArray[filterResult.pos][root] = updateArray
            setPermissions(newDataArray)
        }
    }

    const handleSubmit = async () => {
        setSubmitButton({...submitButton, icon: 'fa fa-spinner fa-spi', disabled: true, text: 'Guardando cambios...'})

        await db.collection("Users").doc(userId).update({
            permits: permissions
        }).then(() => {
            setSubmitButton({...submitButton, icon: 'fas fa-check-circle', disabled: false, text: 'Guardar cambios'})
            const newData = [...data]
            setResult('OK')
            scrollTo('bottom-element')
            setTimeout(() => {
                setResult(null)
            }, 2500)
            newData.forEach(item => {
                if (item.ID === ID) {
                    item.permits = permissions
                }
            })

            setDataUsers(newData)

        }).catch(() => {
            NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
            setSubmitButton({...submitButton, icon: 'fas fa-check-circle', disabled: false, text: 'Guardar cambios'})
        })
    }

    return (
        <>
            <div className="permissions-container">
                <HeaderPage icon={'fas fa-screwdriver'} text={`Permisos para ${userName}`} load={true}/>
                <VerticalSpace space={40}/>
                <LayoutChild padding={10} color="#ECEFF1" radius={3}>
                    <Text hover={false} size={14} weight={'700'} text={'Dashboard'}/>
                </LayoutChild>
                <VerticalSpace space={15}/>
                <CheckBox value={permissions[0].dashboard} text={'Dashboard'} style={{marginTop: 15}}
                          onValueChanged={(e) => onValueSimpleChanged('dashboard', permissions[0].dashboard, e.value)}/>
                <VerticalSpace space={15}/>
                <LayoutChild padding={10} color="#ECEFF1" radius={3} top={15}>
                    <Text hover={false} size={14} weight={'700'} text={'Pasajeros'}/>
                </LayoutChild>
                <VerticalSpace space={15}/>
                <Columns>
                    {permissions[1].passengers.map((item, i) => {
                        return (
                            <CheckBox value={item.value} text={item.text} key={i}
                                      onValueChanged={(e) => onValueCompleteChanged('passengers', item.text, i, e.value)}/>
                        )
                    })}
                </Columns>
                <VerticalSpace space={15}/>
                <LayoutChild padding={10} color="#ECEFF1" radius={3} top={15}>
                    <Text hover={false} size={14} weight={'700'} text={'Conductores'}/>
                </LayoutChild>
                <VerticalSpace space={15}/>
                <Columns>
                    {drivers?.map((item, i) => {
                        return (
                            <CheckBox value={item.value} text={item.text} key={i}
                                      onValueChanged={(e) => onValueCompleteChanged('drivers', item.text, i, e.value)}/>
                        )
                    })}
                </Columns>
                <VerticalSpace space={15}/>
                <LayoutChild padding={10} color="#ECEFF1" radius={3} top={15}>
                    <Text hover={false} size={14} weight={'700'} text={'Gestión de reservas'}/>
                </LayoutChild>
                <CheckBox value={permissions[3].managementBookings} text={'Gestión de reservas'} style={{marginTop: 15}}
                          onValueChanged={(e) => onValueSimpleChanged('managementBookings', permissions[3].managementBookings, e.value)}/>
                <VerticalSpace space={15}/>
                <LayoutChild padding={10} color="#ECEFF1" radius={3} top={15}>
                    <Text hover={false} size={14} weight={'700'} text={'Notificaciones'}/>
                </LayoutChild>
                <CheckBox value={permissions[4].notification} text={'Notificaciones'} style={{marginTop: 15}}
                          onValueChanged={(e) => onValueSimpleChanged('notification', permissions[4].notification, e.value)}/>
                <VerticalSpace space={15}/>
                <LayoutChild padding={10} color="#ECEFF1" radius={3} top={15}>
                    <Text hover={false} size={14} weight={'700'} text={'Promociones'}/>
                </LayoutChild>
                <CheckBox value={permissions[5].promotions} text={'Promociones'} style={{marginTop: 15}}
                          onValueChanged={(e) => onValueSimpleChanged('promotions', permissions[5].promotions, e.value)}/>

                <VerticalSpace space={15}/>
                <LayoutChild padding={10} color="#ECEFF1" radius={3} top={15}>
                    <Text hover={false} size={14} weight={'700'} text={'Reportes'}/>
                </LayoutChild>
                <VerticalSpace space={15}/>
                <Columns>
                    {permissions[6].reports.map((item, i) => {
                        return (
                            <CheckBox value={item.value} text={item.text} key={i}
                                      onValueChanged={(e) => onValueCompleteChanged('reports', item.text, i, e.value)}/>
                        )
                    })}
                </Columns>

                <VerticalSpace space={15}/>
                <LayoutChild padding={10} color="#ECEFF1" radius={3} top={15}>
                    <Text hover={false} size={14} weight={'700'} text={'Configuraciones iniciales'}/>
                </LayoutChild>
                <VerticalSpace space={15}/>
                <Columns>
                    {permissions[7].initialSettings.map((item, i) => {
                        return (
                            <CheckBox value={item.value} text={item.text} key={i}
                                      onValueChanged={(e) => onValueCompleteChanged('initialSettings', item.text, i, e.value)}/>
                        )
                    })}
                </Columns>
                <VerticalSpace space={15}/>
                {result && <Results results={result} text={'Permisos actualizados exitosamente'}/>}
                {result && <VerticalSpace space={15}/>}
                <LayoutChild color="transparent" width={'100%'} center row positionR>
                    <Button id={'save-button-form'}
                            icon={submitButton.icon}
                            disabled={submitButton.disabled}
                            type="success"
                            width={'auto'}
                            text="Guardar cambios"
                            onClick={handleSubmit}/>
                </LayoutChild>
                <Element name="bottom-element" className="element"/>
            </div>
        </>
    )
}

export default Permissions